import {BaseService} from "./BaseService";
import {SensorStat} from "../entities/SensorStatsHistory";
import { StateService } from "@uirouter/angularjs";

export class SensorStatService extends BaseService<SensorStat>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, SensorStat);
    }
    protected getBaseUrl():string{
        return "sensorstat";
    }
    getByVTagId(vtagId:string):ng.IPromise<SensorStat[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"VTag/"+vtagId, config);
    }
    getLastByAssetId(assetId:number):ng.IPromise<SensorStat>{
        var config:any = {};
        return this.useBaseGetHandler(this.getBaseUrl(),"last/"+assetId, config);
    }
}
